<template>
<label class="custom-control custom-checkbox">
    <input class="custom-control-input" type="checkbox" 
        :checked="value"
        :disabled="disabled"
        @change="$emit('input', $event.target.checked)">
    <span class="custom-control-indicator"></span>
    <span class="custom-control-description">
        <template v-if="description">{{ description }}</template>
        <slot v-else />
    </span>
</label>
</template>
<script lang="js">

export default{
    name: 'CustomCheckbox',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        not_muted_when_unchecked: {
            type: Boolean,
            default: false
        }
    }
}
</script>